import {
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from '@/components/ui/dropdown-menu';
import { Briefcase, Sparkles, Wrench, Leaf, Hammer, Home } from 'lucide-react';

/**
 * AddMenuItems — the shared dropdown-menu item cluster used both by
 * the top-right "Add Event" button and each day cell's context menu.
 */
export const AddMenuItems = ({ onPick, label = false }) => (
  <>
    {label && <DropdownMenuLabel>Add to this day</DropdownMenuLabel>}
    {label && <DropdownMenuSeparator />}
    <DropdownMenuItem onClick={() => onPick('booking')} data-testid="add-booking-menu-item">
      <Briefcase className="h-4 w-4 mr-2 text-blue-600" />
      Booking
    </DropdownMenuItem>
    <DropdownMenuItem onClick={() => onPick('owner_use')} data-testid="add-owner-use-menu-item">
      <Home className="h-4 w-4 mr-2 text-rose-600" />
      Owner Use Block
    </DropdownMenuItem>
    <DropdownMenuSeparator />
    <DropdownMenuItem onClick={() => onPick('cleaning')} data-testid="add-cleaning-menu-item">
      <Sparkles className="h-4 w-4 mr-2 text-emerald-600" />
      Cleaning Task
    </DropdownMenuItem>
    <DropdownMenuItem onClick={() => onPick('maintenance')} data-testid="add-maintenance-menu-item">
      <Wrench className="h-4 w-4 mr-2 text-amber-600" />
      Maintenance Task
    </DropdownMenuItem>
    <DropdownMenuItem onClick={() => onPick('landscaping')} data-testid="add-landscaping-menu-item">
      <Leaf className="h-4 w-4 mr-2 text-green-600" />
      Landscaping Task
    </DropdownMenuItem>
    <DropdownMenuItem onClick={() => onPick('renovation')} data-testid="add-renovation-menu-item">
      <Hammer className="h-4 w-4 mr-2 text-violet-600" />
      Renovation Project
    </DropdownMenuItem>
  </>
);

export default AddMenuItems;
